/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/13/20
 *
 */

import BaseObject from "@shared/BaseObject";

export default class UsageStats extends BaseObject {

	activeClientsCount: number = 0

	storageConsumedSize: number = 0
	storageFilesCount: number = 0


	constructor() {
		super();
	}

}
